"use client";
import React, {useEffect, useMemo, useState} from "react";
import {confJson} from "@/app/config/confJson";
import {HttpResponse} from "@/Fwk/Http/HttpConfig";
import {DriveUtil} from "@/Master/DriveUtil";
import BigTips from "@/Master/BigTips";
import styles from "@/app/(redeem)/redeem.module.css";
import {RedeemResult} from "@/Core/Redeem/redeemEntity";
import {RedeemResultCode} from "@/Core/Redeem/redeemEnum";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemCashOutDialogFC} from "@/app/(redeem)/redeemCashOut/RedeemCashOutDialogFC";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import TrackRedeem from "@/Core/Track/TrackRedeem";
import Util from "@/Master/Util";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {selectUserInfo} from "@/app/userSlice";
import {getUserInfoGameBaseAsync} from "@/app/userSliceAPI";
import {RedeemSubmittedDialogFC} from "@/app/(redeem)/UI/RedeemSubmittedDialogFC";
import WebRedeem from "@/Core/Redeem/WebRedeem";
import {getUserId} from "@/app/utils/auth";
import RedeemUtil from "@/Core/Redeem/RedeemUtil";
import BubbleTipFree from "@/app/(redeem)/components/BubbleTipFree/BubbleTipFree";

interface RedeemCashOutUIProps {
    channelData: ResponseRedeemConfigData,
    channelCheckData: ResponseRedeemChannelCheckData
}


export const RedeemCashOutUI: React.FC<RedeemCashOutUIProps> = (props) => {
    const {channelData, channelCheckData} = props;
    const [loading, setLoading] = useState<boolean>(true);
    const [moneyValue, setMoneyValue] = useState('');//兑换金额

    const userInfo = useAppSelector(selectUserInfo);
    const dispatch = useAppDispatch();

    const {availableScAmount} = userInfo

    const [checkData, setCheckData] = useState<ResponseRedeemChannelCheckData>(channelCheckData);

    const money = React.useMemo(
        () => {
            const value = Number(moneyValue);
            if (isNaN(value)) {
                return 0;
            }
            return value;
        },
        [moneyValue]
    );

    const processFeeDollar = React.useMemo(
        () => {
            return DriveUtil.ToDollarString(checkData.feeRatio * money);
        },
        [checkData, money]
    );

    const dollar = React.useMemo(
        () => {
            const v = money - checkData.feeRatio * money;
            return DriveUtil.ToDollarString(v);
        },
        [checkData, money]
    );

    const minMoney = React.useMemo(
        () => Math.max(channelData.minMoney, 50),
        [checkData]
    );

    const maxMoney = React.useMemo(
        () => channelData.maxMoney,
        [checkData]
    );

    useEffect(() => {
        // const {withdrawAccount,country,state,city,zipCode} = channelCheckData;
        // if (withdrawAccount){
        //     // setAccount(withdrawAccount);
        // }
        // setZipCode(zipCode);
        updateChannelCheckData();
    }, []);

    const updateChannelCheckData = async () => {
        const {channelType} = channelData;
        const response = await WebRedeem.Instance.RequestRedeemChannelCheck(channelType, (data: HttpResponse<ResponseRedeemChannelCheckData>) => {
            if (Util.isLog) {
                console.log('CheckRedeemConfig', data);
            }
        });
        if (response?.code == 200) {
            setCheckData(response.data)
        } else {
            const msg = response?.message || response?.description;
            if (msg) {
                BigTips.showMsg(msg);
            }
        }
    }

    const onDoRedeem = async () => {
        const result = new RedeemResult();
        const {withdrawAccount} = checkData;
        const {availableScAmount} = userInfo;
        if (!withdrawAccount) {
            result.code = RedeemResultCode.NotRedeemAccountOk;
            return onRedeemCallBack(result);
        }
        if (money <= 0) {
            result.code = RedeemResultCode.NotZero;
            return onRedeemCallBack(result);
        }
        if (money < minMoney) {
            result.code = RedeemResultCode.NotMinMoney;
            return onRedeemCallBack(result);
        }
        if (money >= maxMoney) {
            result.code = RedeemResultCode.NotMaxMoney;
            return onRedeemCallBack(result);
        }
        if (money > availableScAmount) {
            result.code = RedeemResultCode.NoAvailableToRedeem;
            return onRedeemCallBack(result);
        }
        return onRedeemX(result);
    }

    const onRedeemX = async (result: RedeemResult) => {
        showForceLoading();
        const sendData = {} as RequestRedeemApplyData;
        sendData.currency = 'USD';
        sendData.money = money;
        sendData.withdrawAccount = checkData.withdrawAccount;
        sendData.channelType = checkData.channelType;
        sendData.country = checkData.country;
        sendData.city = checkData.city;
        sendData.state = checkData.state;
        sendData.province = checkData.state;
        sendData.zipCode = checkData.zipCode;
        sendData.userId = getUserId();
        sendData.productId = confJson.productId;
        const response = await WebRedeem.Instance.RequestRedeemApply(sendData);
        hideForceLoading();
        if (response?.code == 200) {
            result.code = RedeemResultCode.Ok;
            result.record = response.data;
        } else {
            result.code = RedeemResultCode.ServerError;
            const msg = response?.message || response?.description;
            if (msg) {
                result.errorMessage = msg;
            }
        }
        return onRedeemCallBack(result);
    }

    const onRedeemCallBack = async (result: RedeemResult) => {
        hideForceLoading();
        switch (result.code) {
            case RedeemResultCode.NotZero:
                BigTips.showMsg("Not Zero");
                break;
            case RedeemResultCode.NoEnoughToMinRedeem:
                BigTips.showMsg("No Enough To Min Redeem");
                break;
            case RedeemResultCode.NotMinMoney:
            case RedeemResultCode.NotMaxMoney:
                BigTips.showMsg("Wrong withdrawal amount");
                break;
            case RedeemResultCode.Ok:
                TrackRedeem.redeem_amount_click(Util.numberToString(result?.record?.money, 3));
                showForceLoading();
                //更新用户基础数据
                await dispatch(getUserInfoGameBaseAsync());
                hideForceLoading();
                TrackRedeem.redeem_submit_show();
                SDialogManagerFC.openDialog(RedeemSubmittedDialogFC, {
                    fcKey: SDialogManagerFC.getFCKey(RedeemSubmittedDialogFC),
                    redeemOrderData: result.record,
                    onClose: () => {
                        // SDialogManagerFC.closeDialogFC(RedeemCashOutDialogFC);
                    }
                });

                SDialogManagerFC.closeDialogFC(RedeemCashOutDialogFC);
                break;
            case RedeemResultCode.ServerError:
                BigTips.showMsg(result.errorMessage);
                break;
            case RedeemResultCode.NoAvailableToRedeem:
                BigTips.showMsg("No Available To Redeem");
                break;
            default:
                BigTips.showMsg(result.code?.toString());
                break;
        }
    }

    const getYuanImgName = () => {
        return `img_y_${RedeemUtil.getChannelTypeName(channelData.channelType)}`;
    }

    const onWithdrawalAmountChange = (value: string) => {
        setMoneyValue(value);
    }

    const onWithdrawalAmountBlur = (value: string) => {
        let newValue = Number(value);
        if (isNaN(newValue)) {
            newValue = 0;
        }
        //自动正
        if (newValue < minMoney){
            setMoneyValue(minMoney+'');
        }
        //自动正
        if (newValue > maxMoney){
            setMoneyValue(maxMoney+'');
        }

    }



    const amountErrTips = () => {
        if (money == 0) return '';

        if (money < minMoney || money >= maxMoney) {
            return `The minimum amount of a single withdrawal is ${DriveUtil.ToScString(minMoney, true)} and the maximum amount is ${DriveUtil.ToScString(maxMoney, true)}.`;
        } else {
            return '';
        }
    }

    return (
        <div className={styles.redeem_cash_out_wrapper}>
            <div className={`redeemCashOut ${styles.redeemCashOut}`}>
                <section className={styles.section}>
                    <div className={`${styles.accountBox}`}>
                        <div className={`${styles.redeemInfo} center-left`}>
                            <div className={`${styles.avatar} center`}>
                                <img src={`/img/redeem/${getYuanImgName()}.webp`}/>
                                {/*<div className={`${styles.iconPen} center`}>*/}
                                {/*    <FontIcon icon={'s-pen'} style={{color: '#fff',fontSize:'0.3rem'}}></FontIcon>*/}
                                {/*</div>*/}
                            </div>

                            <div className={`${styles.accountInfo} text-auto`}>
                                <div className={`${styles.title}`}>Withdrawal Account:</div>
                                <div className={`${styles.account}`}>{checkData.showAccount}</div>
                            </div>
                        </div>

                        <div className={`${styles.redeemInfoBottom}`}>
                            <div className={`${styles.redeemInfoBottom_info}`}>Available to Redeem:<span
                                className={`sc-color`}> {DriveUtil.ToScString(availableScAmount, true)}</span></div>
                            <div className={`${styles.redeemInfoBottom_info} ${styles.redeemInfoBottom_info2} `}>Redeem
                                to (minimum <span className={`err-color`}>{DriveUtil.ToScString(minMoney, true)}</span>)
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.outBox} `}>
                        <div className={`center-left ${styles.eTitle}`}>Withdrawal Amount:</div>
                        <div className={`${styles.outAmount} center-left`}>
                            <div className={`${styles.outAmount_type} center`}>
                                <img src={`/img/redeem/${getYuanImgName()}.webp`}/>
                            </div>
                            <div className={styles.outAmount_input}>
                                <input type='number'
                                       placeholder='Enter Redemption Amount'
                                       value={moneyValue}
                                       onChange={e => onWithdrawalAmountChange(e.target.value)}
                                       onBlur={e => onWithdrawalAmountBlur(e.target.value)}
                                />
                                {amountErrTips() && (
                                    <div className={styles.outAmount_input_err}>
                                        <span>{amountErrTips()}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className={`${styles.outInfo}`}>
                            <div className={`${styles.outInfo_item} center-space-between`}>
                                <div className={`${styles.inf} ${styles.outInfo_txt1} center-left`}>
                                    <span>Processing free </span>
                                    <div style={{position: 'relative'}}>
                                        <BubbleTipFree
                                            text1={`Withdrawals are subject to a ${DriveUtil.ToNormalUnit(checkData.convertFeeRatio) * 100}% fee.`}
                                        />
                                    </div>
                                </div>
                                <div className={`${styles.inf} ${styles.outInfo_txt2}`}><span
                                    style={{fontWeight: '900', color: '#0090FF'}}>{processFeeDollar}</span></div>
                            </div>
                            <div className={`${styles.outInfo_item} center-space-between`}>
                                <div className={`${styles.inf} ${styles.outInfo_txt1}`}>You'll Receive</div>
                                <div className={`${styles.inf} ${styles.outInfo_txt2}`}>
                                    <span style={{fontWeight: '900', color: '#55FF3E'}}>{dollar}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 提交按钮 */}
                    <button
                        type="button"
                        className={`btn ${styles.btn} ${styles.btn_cash_out_confirm}`}
                        onClick={onDoRedeem}
                    >
                        Confirm
                    </button>

                </section>
            </div>
        </div>
    )
}
export default RedeemCashOutUI;
